// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KA7I","clinicsSelect":"styles_clinicsSelect__2TXbl"};